import { useEffect } from 'react';
import { Route, Switch, useHistory, useLocation } from 'react-router';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { AnimatedDashboard } from '../../components/animation/AnimatedDashboard';
import Spinner from '../../components/common/Spinner';
import {
  MY_HUBS_FUTURA_MINING,
  MY_HUBS_GUARDIAN,
  MY_HUBS_MINARA,
  MY_HUBS_U1ACADEMY,
  MY_HUBS_UNICA_PAY
} from '../../routes/routes';
import { Flexed, TabSelectButton, Tabs } from '../../styles/GlobalComponents';

import { GuardianSummary } from './Gardian/GuardianSummary';
import { MembershipStatus } from './MembershipStatus';
import { Overlay } from './Overlay';
import { getMyHubsAkasha, getMyHubsSummary } from './Portfolio.actions';

import { UnicaPaySummary } from './UnicaPay/UnicaPaySummary';
import { MinaraSummary } from './Minara/MinaraSummary';
import { U1AcademySummary } from './U1Academy/U1AcademySummary';
import { FutureMiningSummary } from './FuturaMining/FutureMiningSummary';
import { WalletSummary } from './WalletSummary';
import { isPartnerHelper } from '../../helpers/helperFunctions';

export const Portfolio = () => {
  const dispatch = useAppDispatch();

  const { loading, loadingHubs, akashaPackages, walletSummary } =
    useAppSelector((state) => state.portfolio);

  const { userInfo } = useAppSelector((state) => state.auth);

  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    dispatch(getMyHubsSummary());
    dispatch(getMyHubsAkasha());
  }, [dispatch]);

  const pathname = location.pathname;

  const isPartner = isPartnerHelper(
    userInfo?.user?.currentVirtualOfficeLicence?.dateEnd || ''
  );

  if (loading) return <Spinner fullScreen={true} />;

  return (
    <>
      {isPartner && (
        <AnimatedDashboard zoom dark style={{ marginBottom: '0' }}>
          <MembershipStatus />
        </AnimatedDashboard>
      )}
      <AnimatedDashboard zoom style={{ margin: '0' }}>
        <Tabs style={{ marginBottom: '0' }}>
          <TabSelectButton
            onClick={() => history.push(MY_HUBS_GUARDIAN)}
            selected={pathname === MY_HUBS_GUARDIAN}>
            <div>Plans</div>
          </TabSelectButton>
          <TabSelectButton
            onClick={() => history.push(MY_HUBS_UNICA_PAY)}
            selected={pathname === MY_HUBS_UNICA_PAY}>
            <div>Unica Pay</div>
          </TabSelectButton>
          <TabSelectButton
            onClick={() => history.push(MY_HUBS_MINARA)}
            selected={pathname === MY_HUBS_MINARA}>
            <div>Minara</div>
          </TabSelectButton>
          <TabSelectButton
            onClick={() => history.push(MY_HUBS_U1ACADEMY)}
            selected={pathname === MY_HUBS_U1ACADEMY}>
            <div>U1 Academy</div>
          </TabSelectButton>
          <TabSelectButton
            onClick={() => history.push(MY_HUBS_FUTURA_MINING)}
            selected={pathname === MY_HUBS_FUTURA_MINING}>
            <div>Futura Mining</div>
          </TabSelectButton>
        </Tabs>
      </AnimatedDashboard>
      <AnimatedDashboard zoom dark>
        {/* <WalletSummary /> */}
        {/* <FlipMeBanner isOpen={isOpen} setIsOpen={setIsOpen} /> */}

        {loadingHubs && <Spinner fullScreen={true} transparent />}

        <Switch location={location} key={location.pathname}>
          <Route path={MY_HUBS_GUARDIAN}>
            <GuardianSummary />
          </Route>
          <Route path={MY_HUBS_UNICA_PAY}>
            <UnicaPaySummary />
          </Route>
          <Route path={MY_HUBS_MINARA}>
            <MinaraSummary />
          </Route>
          <Route path={MY_HUBS_U1ACADEMY}>
            <U1AcademySummary />
          </Route>
          <Route path={MY_HUBS_FUTURA_MINING}>
            <FutureMiningSummary />
          </Route>
          {/* <Route path={MY_HUBS_TRAVEL}>
            <TravelSummary />
          </Route>
          <Route path={MY_HUBS_BIG_WHALE}>
            <BigWhaleSummary />
          </Route>
          <Route path={MY_HUBS_TRADING}>
            <TradingHubSummary />
          </Route>
          <Route path={MY_HUBS_PAYMENT}>
            <PaymentHubSummary
              setWithdrawStep={setWithdrawStep}
              withdrawStep={withdrawStep}
            />
          </Route> */}

          {/* <Route path={MY_HUBS_FLIPME_CARDS}>
          <PaymentHubSummary
            setWithdrawStep={setWithdrawStep}
            withdrawStep={withdrawStep}
          />
        </Route>
        <Route path={MY_HUBS_GAMING}>
          <GamingHubSummary
            setWithdrawStep={setWithdrawStep}
            withdrawStep={withdrawStep}
          />
        </Route> */}
        </Switch>

        {/* <Conversion pathname={pathname} /> */}

        {/* <Overlay /> */}
      </AnimatedDashboard>
    </>
  );
};
